import React, { FC, useEffect, useState } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { NavButton, OrangeButton } from 'components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import {
  getConfirmCollectiveStocksBreads,
  getConfirmCollectiveStocksDates,
  getConfirmCollectiveStocksDeletedMonth,
} from 'reducks/confirm/selectors'
import { getStoreRef } from 'reducks/auth/selectors'
import { OrderType } from 'types/checkout'
import { getOrders } from 'reducks/checkout/selectors'
import { getSpecialHolidays } from 'reducks/calendar/selectors'
import { getStocks } from 'reducks/stock/selectors'
import { ConfirmStock } from 'types/stock'
import { CheckoutItemType } from 'types/checkoutItem'
import { useCheckoutItemsFromOrders } from 'hooks/checkout'
import { useQueryStoreName } from 'hooks/store'
import { fetchFutureOrders, initOrders, unsubscribeOrders } from 'reducks/checkout/operations'
import { endOfMonth, isBefore, startOfMonth } from 'date-fns'
import { fetchStocksWithinPeriod, saveCollectiveStocks } from 'reducks/stock/operations'
import { useConfirmDeliveryStocks } from 'hooks/stock'
import { Description, MainHeadline } from 'components/Typography'
import { AlertCard, DeliveryScheduleCollectiveConfirmCardList } from 'components/Card'
import { useFetchStoreDeliveryBreads } from 'hooks/storeDeliveryBread'
const type = 'delivery'

const DeliveryScheduleCollectiveEditConfirmTemplate: FC = () => {
  const dispatch = useDispatch()
  const breads = useSelector((state: State) => getConfirmCollectiveStocksBreads(state))
  const orders: OrderType[] = useSelector((state: State) => getOrders(state))
  const selectedDates: Date[] = useSelector((state: State) => getConfirmCollectiveStocksDates(state))
  const deletedMonth: Date = useSelector((state: State) => getConfirmCollectiveStocksDeletedMonth(state))
  const specialHolidays = useSelector((state: State) => getSpecialHolidays(state))
  const stocks = useSelector((state: State) => getStocks(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))

  const [confirmStocks, setConfirmStocks] = useState<ConfirmStock[]>([])
  const checkoutItems: CheckoutItemType[] = useCheckoutItemsFromOrders(orders)
  const storeName = useQueryStoreName(storeRef)
  const storeDeliveryBreads = useFetchStoreDeliveryBreads()
  // 注文一覧
  useEffect(() => {
    if (!storeRef) return
    dispatch(initOrders())
    dispatch(fetchFutureOrders(storeRef, ['succeeded', 'requires_capture'], [type]))
    return () => {
      dispatch(unsubscribeOrders())
    }
  }, [storeRef])

  // 選択された日付範囲の月初〜月末の在庫データを取得
  useEffect(() => {
    if (!storeRef) return
    const today = new Date()

    if (typeof deletedMonth === 'undefined' && selectedDates.length > 0) {
      const dates = selectedDates.sort((a, b) => (a < b ? -1 : 1))
      const startDate = dates[0]
      const endDate = dates[dates.length - 1]
      dispatch(
        fetchStocksWithinPeriod({
          storeRef,
          type,
          // 月初が今日より前の日付なら、startを今日にする
          startOfMonth: isBefore(today, startOfMonth(startDate)) ? startOfMonth(startDate) : today,
          endOfMonth: endOfMonth(endDate),
        })
      )
    } else {
      dispatch(
        fetchStocksWithinPeriod({
          storeRef,
          type,
          // 月初が今日より前の日付なら、startを今日にする
          startOfMonth: isBefore(today, startOfMonth(deletedMonth)) ? startOfMonth(deletedMonth) : today,
          endOfMonth: endOfMonth(deletedMonth),
        })
      )
    }
  }, [storeRef, selectedDates, deletedMonth, type])

  useConfirmDeliveryStocks(
    breads,
    selectedDates,
    setConfirmStocks,
    specialHolidays,
    stocks,
    storeDeliveryBreads,
    storeName,
    storeRef
  )

  const showingConfirmedStocks = confirmStocks.filter(
    (confirmStock) => confirmStock.addedStocks.length > 0 || confirmStock.deletedStocks.length > 0
  )

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'修正内容の確認'} />
      <Spacer size={20} />
      {showingConfirmedStocks.length > 0 ? (
        <>
          <AlertCard
            description={
              '登録される日は青字、削除される日は赤字で表示しています。必ずご確認いただき保存を行ってください。'
            }
            headline={'お届け可能日を確認してください。'}
            title={'注意'}
          />
          <Spacer size={16} />
          <OrangeButton
            label={'保存する'}
            onClick={() => dispatch(saveCollectiveStocks(breads, confirmStocks, checkoutItems, type))}
            size={'medium'}
            type={'main'}
          />
          <Spacer size={48} />
          <DeliveryScheduleCollectiveConfirmCardList
            confirmStocks={confirmStocks}
            storeDeliveryBreads={storeDeliveryBreads}
          />
        </>
      ) : (
        <Description description={'すでに登録されているお届け可能日に変更はありません。'} />
      )}
      <Spacer size={48} />
      <OrangeButton
        label={'保存する'}
        onClick={() => dispatch(saveCollectiveStocks(breads, confirmStocks, checkoutItems, type))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={20} />
      <NavButton
        label={'事前予約受付設定に戻る'}
        iconPath={'/icon/grey/arrow_prev.svg'}
        url={'/schedule/delivery/collective_setting'}
      />
      <Spacer size={72} />
    </div>
  )
}

export default DeliveryScheduleCollectiveEditConfirmTemplate
